module.exports = __webpack_public_path__ + "static/media/CarolinaAleHouse.d1bf4c4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/CarolinaAleHouse.png
// module id = 47
// module chunks = 0